<template>
  <li>
    <p>{{ publication.authors }}, <b>{{ publication.title }}</b>, {{ publication.bibliographic_data }}<br><small><i>Descriptores: {{ publication.descriptors }}</i></small></p>
    <p><a v-bind:href="publication.file" target="_blank" rel=”nofollow class="btn btn-primary">Ver publicación</a></p>
  </li>
</template>

<script>
export default {
    props: ["publication"],
    methods: {
        showMore(id) {
            this.$emit('showModal', id)
        }
    }
};
</script>
